import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Volume2, VolumeX } from 'lucide-react';

interface UnsupportedCodecFile {
  fileName: string;
  audioCodec: string;
}

interface UnsupportedAudioCodecDialogProps {
  open: boolean;
  files: UnsupportedCodecFile[];
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Dialog shown when importing media files with unsupported audio codecs.
 * Informs the user that waveform visualization won't be available for these files.
 */
export function UnsupportedAudioCodecDialog({
  open,
  files,
  onConfirm,
  onCancel,
}: UnsupportedAudioCodecDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent className="sm:max-w-[500px] overflow-hidden">
        <AlertDialogHeader className="overflow-hidden">
          <AlertDialogTitle className="flex items-center gap-2">
            <VolumeX className="w-5 h-5 text-yellow-500 shrink-0" />
            Неподдерживаемый аудио-кодек
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                {files.length === 1
                  ? 'Этот файл использует'
                  : `${files.length} файла используют`}{' '}
                аудио-кодек, который не может быть декодирован в браузере. Визуализация звуковой волны будет недоступна.
              </p>

              <div className="max-h-[200px] overflow-y-auto overflow-x-hidden space-y-2">
                {files.map((file, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-[auto_1fr_auto] items-center gap-2 p-2 bg-secondary/50 rounded text-sm"
                  >
                    <Volume2 className="w-4 h-4 text-muted-foreground" />
                    <span className="truncate" title={file.fileName}>{file.fileName}</span>
                    <span className="text-xs text-muted-foreground px-1.5 py-0.5 bg-secondary rounded uppercase whitespace-nowrap">
                      {file.audioCodec}
                    </span>
                  </div>
                ))}
              </div>

              <p className="text-xs text-muted-foreground">
                Видео воспроизведение и редактирование будут работать как обычно. Затронута только визуализация звуковой волны.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Отменить импорт</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Импортировать в любом случае
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
